import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";
const headerHeight = 110;

const headerStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: headerHeight,
  background: "#2373f0",
  color: "#fff",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  zIndex: 1100,
  boxShadow: "0 0 10px rgba(0,0,0,0.15)"
};

const headerInnerStyle = {
  width: "100%",
  maxWidth: 1100,
  padding: "14px 0 8px 32px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
};

const titleStyle = {
  fontWeight: 700,
  fontSize: 28,
  letterSpacing: "-0.02em",
  marginRight: 80,
  marginBottom: 4,
};

const jobIdStyle = {
  fontWeight: 500,
  fontSize: 20,
  letterSpacing: "0.02em"
};

const closeButtonStyle = {
  position: "fixed",
  top: 22,
  right: 22,
  fontSize: 32,
  border: "none",
  background: "transparent",
  color: "#dde7ff",
  cursor: "pointer",
  fontWeight: "bold",
  zIndex: 1150,
};

const overlayStyle = {
  position: "fixed",
  top: headerHeight,
  left: 0,
  width: "100vw",
  height: `calc(100vh - ${headerHeight}px)`,
  background: "rgba(0,0,0,0.1)",
  display: "flex",
  justifyContent: "center",
  alignItems: "stretch",
  // overflowY: "auto",   <-- REMOVE THIS
  zIndex: 1090,
};


const chatContainerStyle = {
  background: "#f7fafe",
  borderRadius: 12,
  padding: "18px 0 0 0",
  color: "#233253",
  fontSize: "1.08rem",
  fontWeight: 500,
  marginTop: -50,
  marginBottom: 0,         // flush with page bottom
  width: "70vw",           // increase to 90% of viewport width
  maxWidth: "1400px",      // optionally set a larger maxWidth or remove
  minHeight: 400,
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  overflowY: "auto",
  height: "420px",
  alignSelf: "center",     // center the container (if inside flex)
};


const botMsgStyle = {
  alignSelf: "flex-start",
  background: "#fff",
  borderRadius: "12px 12px 12px 4px",
  boxShadow: "0 2px 8px rgba(38,129,231,.09)",
  padding: "14px 18px",
  marginBottom: 2,
  display: "flex",
  alignItems: "center",
  maxWidth: "80%",
};

const userMsgStyle = {
  alignSelf: "flex-end",
  background: "#e3eafc",
  borderRadius: "12px 12px 4px 12px",
  boxShadow: "0 2px 8px rgba(38,129,231,.09)",
  padding: "14px 18px",
  marginBottom: 2,
  display: "flex",
  alignItems: "center",
  maxWidth: "80%",
  wordBreak: "break-word",     // <-- this is critical
  whiteSpace: "pre-wrap",
};

const inputRowStyle = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  background: "#fff",
  borderRadius: 8,
  width: "70vw",
  boxShadow: "0 2px 8px rgba(38,129,231,.09)",
  padding: "8px 12px",
  marginTop: 50,
  marginBottom: 0,  // <-- flush with bottom of chat
};

const progressItemStyle = {
  display: "flex",
  alignItems: "center",
  fontWeight: 500,
  fontSize: 16,
  color: "#233253",
  padding: "10px 32px",
  marginBottom: 6,
  borderRadius: 8,
  background: "none",
  border: "none",
  outline: "none",
  cursor: "default",
};

const updatedProgressItemStyle = {
  ...progressItemStyle,
  color: "#9399a8", // Dimmer color for inactive
  fontWeight: 500,
};
const updatedProgressItemActiveStyle = {
  ...updatedProgressItemStyle,
  background: "#295bd8ff",
  color: "#ffffffff", // Strong blue for active
  fontWeight: 700,
};

const inputBoxStyle = {
  flex: 1,
  padding: "12px 18px",
  borderRadius: 8,
  border: "1px solid #e3eafc",
  fontSize: "1.08rem",
  background: "#fff",
  outline: "none",
};

const sendBtnStyle = {
  background: "#a3c6fa",
  border: "none",
  borderRadius: "8px",
  padding: "0 12px",
  height: "44px",
  marginLeft: "8px",
  cursor: "pointer",
  fontSize: "1.3rem",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const modalStyle = {
  width: "100vw",
  height: "100%",
  background: "#fff",
  borderRadius: 0,
  boxShadow: "0 8px 26px rgba(38,129,231,.09)",
  display: "flex",
  fontFamily: "'Segoe UI','Roboto',Arial,sans-serif",
  position: "relative",
  minHeight: "100%",
  marginBottom: 0,
};

const sidebarStyle = {
  position: "fixed",
  top: headerHeight,
  left: 0,
  width: 240,
  background: "#f7fafe",
  borderRight: "1px solid #e3eafc",
  padding: "38px 0 0 32px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  minHeight: `calc(100vh - ${headerHeight}px)`,
  zIndex: 1080,
};

const chooseButtonStyle = {
  marginTop: 10,
  backgroundColor: '#2373f0',
  color: '#fff',
  border: 'none',
  borderRadius: 6,
  padding: '8px 14px',
  cursor: 'pointer',
  fontWeight: '600'
};

const progressLabelStyle = {
  fontWeight: 700,
  fontSize: 17,
  color: "#233253",
  marginBottom: 18,
  marginLeft: 32,
};

const inputStyle = {
  width: "100%",
  fontSize: "1rem",
  padding: "10px 12px",
  borderRadius: 6,
  border: "1.5px solid #dde6f2",
  background: "#f7fafc",
  boxSizing: "border-box",
};


const progressItemActiveStyle = {
  ...progressItemStyle,
  background: "#e3eafc",
  color: "#2373f0",
  fontWeight: 700,
};

const progressItemCheckedStyle = {
  ...progressItemStyle,
  color: "#53b775",
  fontWeight: 700,
};

const progressItemIconStyle = {
  marginRight: 10,
  fontSize: 18,
};

const chatBubbleStyle = {
  background: "#fff",
  borderRadius: 12,
  boxShadow: "0 2px 8px rgba(38,129,231,.09)",
  padding: "18px 22px",
  color: "#233253",
  fontSize: "1.08rem",
  fontWeight: 500,
  marginTop: 18,
  marginBottom: 18,
  maxWidth: 600,
  marginRight: 202,
  textAlign: "left",
  display: "flex",
  alignItems: "center",
  marginLeft: 0,
};

const chooseFileButtonStyle = {
  marginTop: 0,
  background: "#2373f0",
  color: "#fff",
  border: "none",
  borderRadius: 7,
  padding: "6px 12px", // less horizontal/vertical padding
  fontWeight: 600,
  fontSize: "0.98rem", // slightly smaller font
  cursor: "pointer",
  boxShadow: "0 2px 8px rgba(38,129,231,.09)",
  minWidth: 64, // smaller minimum width
  height: "38px", // match or slightly less than chat input/send height
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};


const contentStyle = {
  flex: 1,
  background: "#f7fafe",
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  padding: "55px 100px 100px 60px",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minHeight: "100%",
  justifyContent: "flex-start",
};

const chatbotImgStyle = {
  width: 40,
  height: 40,
  borderRadius: "50%",
  marginRight: 24,
  background: "#e3eafc",
  objectFit: "cover",
  boxShadow: "0 2px 8px rgba(38,129,231,.09)",
};

const dropZoneStyle = (dragActive) => ({
  border: "2.2px dashed #80baff",
  borderRadius: 13,
  background: "#f2f7fe",
  minHeight: 220,
  width: 600,
  textAlign: "center",
  padding: 32,
  marginTop: 16,
  marginBottom: 22,
  marginLeft: 290,
  marginRight: 32,
  cursor: "pointer",
  outline: dragActive ? "2px solid #4686ff" : "none",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  transition: "border-color 0.2s",
});


const steps = [
  { label: "Resume Upload", icon: "📄" },
  { label: "Additional Details", icon: "📝" },
  { label: "Review & Submit", icon: "✅" },
];



export default function ApplyModal({ onClose, job = { jobrole: "Senior Frontend Developer", jobid: "JOB001" }, onSuccess }) {
  const fileInputRef = useRef();
  const coverLetterInputRef = useRef();
  const chatEndRef = useRef();
  const [processingScreening, setProcessingScreening] = useState(false);
  const [screeningError, setScreeningError] = useState(null);

  function getDynamicQuestions(job) {
    // Map job.onboarding keys to standard config
    const questionDefs = {
      linkedin: {
        type: 'text',
        placeholder: 'Enter your LinkedIn URL'
      },
      has_cover_letter: {
        type: 'options',
        options: ['Yes', 'No']
      },
      cover_letter: {
        type: 'coverLetter',
        placeholder: 'Write your cover letter or upload a file'
      },
      work_mode: {
        type: 'options',
        // Dynamic options:
        options: Array.isArray(job.workMode) ? job.workMode : ['Onsite', 'Remote', 'Hybrid']
      },
      preferred_city: {
        type: 'options',
        options: Array.isArray(job.location)
          ? job.location
          : (job.location ? job.location.split(/[\s,]+/) : ['Chennai', 'Bangalore', 'Hyderabad'])
      },
      current_location: {
        type: 'text',
        placeholder: 'Enter your current city or location'
      },
      notice_period: {
        type: 'options',
        options: ['Immediate', '1-2 months', '3 months', '6 months', 'More than 6 months']
      },
      current_salary: {
        type: 'text',
        placeholder: 'Enter your current salary or NA if fresher'
      },
      expected_salary: {
        type: 'number',
        placeholder: 'Enter your expected salary'
      },
      job_change_reason: {
        type: 'text',
        placeholder: 'Please share your reason for changing job'
      },
      career_gap_reason: {
        type: 'text',
        placeholder: "If no gap, please type 'No'"
      },
      interview_date: { type: 'date' },
      interview_time_slots: {
        type: 'options',
        options: Array.isArray(job.onboarding?.interview_time_slots?.value)
          ? job.onboarding.interview_time_slots.value
          : []
      },
      legally_authorized: {
        type: 'options',
        options: ['Yes', 'No']
      },
      open_to_relocate: {
        type: 'options',
        options: ['Yes', 'No']
      },
      found_us: {
        type: 'text',
        placeholder: 'Please specify'
      },
      // Add more as you formalize
    };

    return Object.keys(job.onboarding || {}).map(key => {
      const onboardingDef = questionDefs[key];
      return {
        key,
        text: job.onboarding[key].label || key,
        ...(onboardingDef || { type: 'text', placeholder: 'Enter your response' })
      };
    });



    // Remote or Work From Home jobs
    //   if (job.workMode) {
    //   // Ensure workMode is always an array, even if single string
    //   const workModeOptions = Array.isArray(job.workMode)
    //     ? job.workMode
    //     : [job.workMode];

    //   return questions.map((q) => {
    //     if (q.key === "workMode") {
    //       return { ...q, options: workModeOptions };
    //     }
    //     if (q.key === "preferredCity" && job.location) {
    //       const cities = Array.isArray(job.location)
    //         ? job.location
    //         : job.location.split(/[,\s]+/);

    //       return { ...q, options: cities };
    //     }
    //     return q;
    //   });
    // }
  };

  const additionalQuestions = getDynamicQuestions(job);
  const [dragActive, setDragActive] = useState(false);
  const [resume, setResume] = useState(null);
  const [coverLetterDragActive, setCoverLetterDragActive] = useState(false);
  const handleCoverLetterDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (["dragenter", "dragover"].includes(e.type)) {
      setCoverLetterDragActive(true);
    }
    if (e.type === "dragleave") {
      setCoverLetterDragActive(false);
    }
  };

  const handleCoverLetterDrop = (e) => {
    e.preventDefault();
    setCoverLetterDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      if (validateFile(file)) {
        setCoverLetterFile(file);
        setCoverLetterName(file.name);
        setCoverLetterText("");
      }
    }
  };
  const [step, setStep] = useState(0); // 0: Resume, 1: Additional Details, 2: Review
  const [questionIdx, setQuestionIdx] = useState(0);
  const [isOptionDisabled, setIsOptionDisabled] = useState(false);
  const [coverLetterName, setCoverLetterName] = useState("");
  const [uploading, setUploading] = useState(false);
  const [coverLetterText, setCoverLetterText] = useState("");
  const [coverLetterFile, setCoverLetterFile] = useState(null);
  const [answers, setAnswers] = useState({});
  const [isEditingAll, setIsEditingAll] = useState(false);
  const [editAllValues, setEditAllValues] = useState({});
  const [isVerified, setIsVerified] = useState(false);
  const [showTimeOverlay, setShowTimeOverlay] = useState(false);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState("");
  const [candidateId, setCandidateId] = useState(null);
  const [personalInfo, setPersonalInfo] = useState({
    first_name: undefined,
    last_name: undefined,
    email: undefined,
    phone: undefined
  });
  const requiredFields = [
    personalInfo.first_name,
    personalInfo.last_name,
    personalInfo.email,
    personalInfo.phone
  ];
  const isExtracting = requiredFields.some(field => field === undefined);
  const today = new Date();
  const minSelectableDate = new Date();
  minSelectableDate.setDate(today.getDate() + 3);

  const maxSelectableDate = new Date();
  maxSelectableDate.setMonth(today.getMonth() + 6);

  const formatDate = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };
  const [canProceedToStep3, setCanProceedToStep3] = useState(false);
  const [polling, setPolling] = useState(false);
  const [loading, setLoading] = useState(false);
  const [candidateFields, setCandidateFields] = useState({
    linkedin: "",
    cover_letter: "",
    work_mode: "",
    preferred_city: "",
    notice_period: "",
    current_salary: "",
    expected_salary: "",
    interview_date: "",
    interview_time_slots: "",
    legally_authorized: false
  });
  const preferredCityIdx = additionalQuestions.findIndex(q => q.key === "preferredCity");
  const coverLetterValue = editAllValues.coverLetter || "";
  const isFile = typeof coverLetterValue === "string" && coverLetterValue.includes("_");
  const prefillText = isFile ? "" : coverLetterValue;

  // Chat array structure changed to store question and answer pairs in step 1
  // Each question and answer are separate objects for distinct display
  const [chat, setChat] = useState([
    { type: "bot", text: additionalQuestions[0].text }
  ]);
  const [input, setInput] = useState("");
  const [fileValidationError, setFileValidationError] = useState("");

  // API Base URL
  // const API_BASE_URL = "https://screening.fanisko.com";
  // const API_BASE_URL = "http://127.0.0.1:8000";

  const validateFile = (file) => {
    if (!file) return false;
    const validExtensions = ['.pdf', '.docx'];
    const fileName = file.name.toLowerCase();
    const isSupported = validExtensions.some(ext => fileName.endsWith(ext));
    if (!isSupported) {
      setFileValidationError("Please upload a supported file format (PDF and DOCX).");
      return false;
    }
    const maxSize = 5 * 1024 * 1024; // 5MB limit
    if (file.size > maxSize) {
      setFileValidationError("File size exceeds 5MB limit. Please upload a smaller file.");
      return false;
    }
    return true;
  };

  useEffect(() => {
    // Scroll chat to bottom whenever chat changes
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chat]);

  const handleCoverLetterChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      if (validateFile(file)) {
        setCoverLetterFile(file);
        setCoverLetterName(file.name); // store name for UI only
      } else {
        e.target.value = null;
      }
    }
  };

  function validateLinkedInUrlFrontend(url) {
    const regex = /^(https?:\/\/)?(([\w-]+\.)?linkedin\.com)\/in\/[A-Za-z0-9\-_%]+\/?(\?.*)?$/i;
    return regex.test(url.trim());
  }


  function validateCurrentSalary(value) {
    if (typeof value === "string") {
      const trimmedVal = value.trim();
      if (trimmedVal.toUpperCase() === "NA") return true;
      const numVal = Number(trimmedVal);
      return !isNaN(numVal) && numVal > 0;
    }
    if (typeof value === "number") {
      return value > 0;
    }
    return false;
  }

  function validateExpectedSalary(value, currentSalary) {
    // Reject if negative, decimal, or zero
    if (!/^\d+$/.test(value)) return false;

    const numValue = Number(value);

    if (numValue <= 0) return false;

    // Current salary can be 'NA' or number
    if (typeof currentSalary === "string" && currentSalary.toUpperCase() === "NA") {
      return true;
    }

    const currentNum = Number(currentSalary);

    // If current salary is a valid number, expected salary must be >= current salary
    return !isNaN(currentNum) && numValue >= currentNum;
  }

  function validateInterviewDate(inputDate) {
    if (!inputDate) return false;
    // Parse the date string from input as local date midnight
    const dateValue = new Date(inputDate + "T00:00:00");
    if (isNaN(dateValue)) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const minDate = new Date(today);
    minDate.setDate(minDate.getDate() + 3);
    minDate.setHours(0, 0, 0, 0);

    const maxDate = new Date(today);
    maxDate.setMonth(today.getMonth() + 6);
    maxDate.setHours(0, 0, 0, 0);

    return dateValue >= minDate && dateValue <= maxDate;
  }

  async function sendAnswer(key, val, displayVal) {
    if (
      key !== "preferredCity" && // allow empty for preferred city
      (val === undefined || val === null || (typeof val === "string" && val.trim() === ""))
    ) {
      alert("This field cannot be empty. Please provide a valid value.");
      return;
    }
    if (key === "linkedin") {
      const isValid = validateLinkedInUrlFrontend(val);
      if (!isValid) {
        alert("Please enter a valid LinkedIn profile URL.");
        return;
      }
    }
    if (key === "current_salary") {
      if (!validateCurrentSalary(val)) {
        alert("Please enter a positive number for current salary or 'NA' if not applicable.");
        return;
      }
    }
    if (key === "expected_salary") {
      if (!validateExpectedSalary(val, answers.current_salary)) {
        alert("Expected salary must be a positive integer and not less than current salary unless current salary is 'NA'.");
        return;
      }
    }
    if (key === "has_cover_letter") {
      if (!["Yes", "No"].includes(val)) {
        alert("Please select Yes or No for cover letter option.");
        return;
      }
    }

    if (key === "current_location") {
      if (typeof val !== "string" || val.trim().length < 2) {
        alert("Please enter a valid current location.");
        return;
      }
    }

    if (key === "job_change_reason") {
      if (typeof val !== "string" || val.trim().length < 10) {
        alert("Please provide a detailed reason for job change (at least 10 characters).");
        return;
      }
    }

    if (key === "careerGap") {
      if (
        typeof val !== "string" ||
        !(val.trim().toLowerCase() === "no" || val.trim().length >= 5)
      ) {
        alert("Please enter 'No' or a reason describing your career gap.");
        return;
      }
    }

    if (key === "openToRelocate") {
      if (!["Yes", "No"].includes(val)) {
        alert("Please select Yes or No for relocation ability.");
        return;
      }
    }

    if (key === "foundUs") {
      if (typeof val !== "string" || val.trim().length < 3) {
        alert("Please specify how you found us.");
        return;
      }
    }

    if (key === "interview_date") {
      if (!validateInterviewDate(val)) {
        alert("Please select an interview date between 3 days from today and 6 months from today.");
        return;
      }
    }
    // Update answers state
    setAnswers((prev) => ({ ...prev, [key]: val }));

    // Append user answer to chat
    setChat((prev) => [...prev, { type: "user", text: displayVal || val }]);

    let nextIdx = questionIdx + 1;
    if (
      additionalQuestions[nextIdx]?.key === "cover_letter" &&
      (key === "has_cover_letter" ? val : answers.has_cover_letter) === "No"
    ) {
      nextIdx++;
    }
    // If the next question is preferredCity AND user chose Work From Home, skip it
    if (
      additionalQuestions[nextIdx]?.key === "preferred_city" &&
      (key === "work_mode" ? val : answers.workMode) === "Remote"
    ) {
      nextIdx++;
    }

    if (nextIdx < additionalQuestions.length) {
      setTimeout(() => {
        setQuestionIdx(nextIdx);
        setChat((prev) => [
          ...prev,
          { type: "bot", text: additionalQuestions[nextIdx].text },
        ]);
      }, 400);
    } else {
      setTimeout(() => {
        setStep(2);
        setChat((prev) => [
          ...prev,
          { type: "bot", text: "🎉 Awesome! Got your info. Let's keep the momentum going!" },
        ]);
      }, 400);
    }

    // Clear inputs
    setInput("");
    setCoverLetterText("");
    setCoverLetterFile(null);
  }

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      if (validateFile(file)) {
        setResume(file);
      }
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") setDragActive(true);
    if (e.type === "dragleave") setDragActive(false);
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      if (validateFile(file)) {
        setResume(file);
      }
    }
    e.target.value = null;
  };

  const handleNext = (e) => {
    e.preventDefault();

    if (!resume) {
      alert("Please upload your resume.");
      return;
    }

    // Create FormData for backend upload
    const formData = new FormData();
    formData.append("resume", resume);
    formData.append("jobid", job.jobid);
    formData.append("jobrole", job.jobrole);

    // Fire the backend resume upload API asynchronously
    // axios.post("https://screening.fanisko.com/api/upload_resume", formData, {   
    axios.post(`${API_BASE_URL}/api/upload_resume`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(res => {
        setCandidateId(res.data.candidate_id);
        setPersonalInfo(res.data.personal_info);
        setCanProceedToStep3(true);
      })
      .catch(err => {
        console.error("Resume upload failed:", err);
        setCanProceedToStep3(false);
      });

    // Immediately move to next step without waiting on API response
    setStep(1);
  };

  const handleAnswer = (key, value, displayVal) => {
    sendAnswer(key, value, displayVal);
  };


  useEffect(() => {
    if (step !== 1 || !candidateId) return;

    setPolling(true);
    let cancelled = false;

    const pollForReady = async () => {
      for (let i = 0; i < 120; i++) {  // Poll max 4 minutes
        if (cancelled) return;

        try {
          // const response = await axios.get(`https://screening.fanisko.com/api/personal_info_status/${candidateId}`);
          const response = await axios.get(`${API_BASE_URL}/api/personal_info_status/${candidateId}`);
          if (response.data?.ready) {
            setPersonalInfo(response.data.personal_info);
            setCanProceedToStep3(true);  // Allow user to proceed
            setPolling(false);
            return;  // Stop polling
          }
        } catch {
          // ignore and continue polling
        }
        await new Promise(res => setTimeout(res, 2000));
      }
      if (!cancelled) setPolling(false);
    };

    pollForReady();

    return () => {
      cancelled = true;
      setPolling(false);
    };
  }, [step, candidateId]);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleFinalSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!personalInfo.first_name?.trim()) {
      alert("First name is required.");
      setLoading(false);
      return;
    }
    if (!personalInfo.last_name?.trim()) {
      alert("Last name is required.");
      setLoading(false);
      return;
    }
    if (!personalInfo.email?.trim() || !validateEmail(personalInfo.email.trim())) {
      alert("Please enter a valid email address.");
      setLoading(false);
      return;
    }
    if (!personalInfo.phone?.trim()) {
      alert("Phone number is required.");
      setLoading(false);
      return;
    }
    // Additional custom field validations
    // Dynamic validation for all onboarding questions
    for (const q of additionalQuestions) {
      const val = answers[q.key];
      if (
        q.key === "preferred_city" &&
        (answers["work_mode"] === "Remote" || answers["workMode"] === "Remote")
      ) {
        // Skip validation for preferred city in this case
        continue;
      }
      // Generic required check
      // if (!val || (typeof val === 'string' && val.trim() === '')) {
      //   alert(`Please enter a value for: ${q.text}`);
      //   setLoading(false);
      //   return;
      // }
      // Location validation by label
      if (q.type === 'text' && q.text.toLowerCase().includes('location') && val.trim().length < 2) {
        alert('Please enter a valid location (at least 2 characters).');
        setLoading(false);
        return;
      }
      // Email or LinkedIn by key
      if (q.key.toLowerCase().includes('email') && !validateEmail(val.trim())) {
        alert('Please enter a valid email address.');
        setLoading(false);
        return;
      }
      if (q.key.toLowerCase().includes('linkedin')) {
        const linkedInRx = /^(https?:\/\/)?([\w-]+\.)?linkedin\.com\/in\/[A-Za-z0-9\-%]+\/?/i;
        if (!linkedInRx.test(val.trim())) {
          alert('Please enter a valid LinkedIn profile URL.');
          setLoading(false);
          return;
        }
      }
      // Numeric validation
      if (q.type === 'number' && (isNaN(val) || Number(val) <= 0)) {
        alert(`Please enter a positive number for: ${q.text}`);
        setLoading(false);
        return;
      }
      // Options validation
      if (q.type === 'options' && Array.isArray(q.options) && !q.options.includes(val)) {
        alert(`Please select a valid option for: ${q.text}`);
        setLoading(false);
        return;
      }
      // Reason for job change (length check)
      if (q.text.toLowerCase().includes('job change') && val.trim().length < 10) {
        alert('Please provide a detailed reason for job change (at least 10 characters).');
        setLoading(false);
        return;
      }
      // Career gap validation
      if (q.text.toLowerCase().includes('career gap') && !(val.trim().toLowerCase() === 'no' || val.trim().length >= 5)) {
        alert("Please enter 'No' or state the gap reason.");
        setLoading(false);
        return;
      }
      // Cover letter field validation
      if (q.key === 'cover_letter' && answers['has_cover_letter'] === 'Yes' && (!val || val.trim() === '')) {
        alert('Please upload your cover letter or provide text.');
        setLoading(false);
        return;
      }
      // Date validation (interview_date)
      if (q.type === 'date' && q.key === 'interview_date' && !validateInterviewDate(val)) {
        alert('Please select an interview date between 3 days from today and 6 months from today.');
        setLoading(false);
        return;
      }
    }

    try {
      console.log("Submitting candidate info...");

      // Prepare candidate info including cover letter name
      const candidateData = {
        candidate_id: candidateId,
        job_id: job.jobid,
        ...personalInfo,
        ...answers,
        coverLetterName: editAllValues.coverLetter || null, // file name
      };

      // Store candidate info first (without full file)
      console.log("Prepared candidateData for submission:", candidateData);
      // const storeRes = await axios.post("https://screening.fanisko.com/api/store_candidate_info", candidateData);
      const storeRes = await axios.post(`${API_BASE_URL}/api/store_candidate_info`, candidateData);
      console.log("Candidate info stored successfully.", storeRes.data);
      console.log("Prepared candidateData for submission::::::::", candidateData);

      setLoading(false);
      setProcessingScreening(true);
      setScreeningError(null);
      let score = 0;
      let attempts = 0;
      const MAX_ATTEMPTS = 40; // For 40 x 2s = max 80 seconds
      let screeningSuccess = false;

      while (!screeningSuccess && attempts < MAX_ATTEMPTS) {
        attempts += 1;
        try {
          const screeningResponse = await axios.get(
            // `https://screening.fanisko.com/api/get_initial_screening_result/${candidateId}`
            `${API_BASE_URL}/api/get_initial_screening_result/${candidateId}`
          );
          const rawScore = screeningResponse.data?.score;
          score = Number(rawScore);
          if (!isNaN(score)) {
            screeningSuccess = true;
            break;
          }
        } catch (e) {
          // Optionally log or set error message for retrying
        }
        await new Promise(res => setTimeout(res, 2000));
      }

      setProcessingScreening(false);

      if (!screeningSuccess) {
        setScreeningError("Screening is still processing. Please try again in a moment.");
        return;
      }

      // Final screening trigger
      if (score >= 40) {
        try {
          // await axios.post(`https://screening.fanisko.com/api/run_final_screening?candidate_id=${candidateId}&job_id=${job.jobid}`);
          await axios.post(`${API_BASE_URL}/api/run_final_screening?candidate_id=${candidateId}&job_id=${job.jobid}`);
        } catch (err) {
          console.error("Error triggering final screening:", err);
        }
      }

      // Success callback
      if (onSuccess) {
        onSuccess(personalInfo.first_name, job, score, candidateId);
      }
    } catch (e) {
      setProcessingScreening(false);
      setScreeningError("An unexpected error occurred. Please try again later.");
      console.error("Error during final submit:", e);
    }
  };

  return (
    <>
      {/* File Validation Modal */}
      {fileValidationError && (
        <div style={{
          position: "fixed",
          top: 0, left: 0, width: "100%", height: "100%",
          background: "rgba(0,0,0,0.4)",
          display: "flex", alignItems: "center", justifyContent: "center",
          zIndex: 10000,
          backdropFilter: "blur(2px)"
        }}>
          <div style={{
            background: "#fff",
            borderRadius: 16,
            boxShadow: "0 8px 32px rgba(38,129,231,0.15)",
            padding: "36px 48px",
            minWidth: 340,
            maxWidth: 480,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center"
          }}>
            <div style={{ fontWeight: 600, color: "#d9534f", fontSize: 24, marginBottom: 12 }}>
              Oops!
            </div>
            <div style={{ fontWeight: 500, color: "#244356", fontSize: 17, marginBottom: 28, lineHeight: 1.5 }}>
              {fileValidationError}
            </div>
            <button
              onClick={() => setFileValidationError("")}
              style={{
                background: "#2373f0",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "10px 32px",
                fontWeight: 600,
                fontSize: 16,
                cursor: "pointer",
                transition: "background 0.2s"
              }}
              onMouseOver={(e) => e.target.style.background = "#1b5bc2"}
              onMouseOut={(e) => e.target.style.background = "#2373f0"}
            >
              OK
            </button>
          </div>
        </div>
      )}
      {/* Processing screening loader overlay */}
      {processingScreening && (
        <div style={{
          position: "fixed",
          top: 0, left: 0, width: "100vw", height: "100vh",
          background: "rgba(0,0,0,0.08)",
          display: "flex", alignItems: "center", justifyContent: "center",
          zIndex: 9999
        }}>
          <div style={{
            background: "#fff",
            borderRadius: 16,
            boxShadow: "0 4px 28px rgba(38,129,231,0.13)",
            padding: "40px 48px",
            minWidth: 340,
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}>
            <svg width={48} height={48} viewBox="0 0 50 50">
              <circle
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke="#2684ff"
                strokeWidth="5"
                strokeLinecap="round"
                strokeDasharray="31.4 94.2"
                style={{ transformOrigin: 'center', animation: 'spin 1.2s linear infinite' }}
              />
              <style>{`@keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
            </svg>
            <div style={{ marginTop: 22, marginBottom: 6, fontWeight: 600, color: "#244356", fontSize: 18, textAlign: "center" }}>
              Resume is processing.....
            </div>
            {screeningError && (
              <div style={{ color: "red", fontSize: 16, marginTop: 8, textAlign: "center" }}>
                {screeningError}
              </div>
            )}
          </div>
        </div>
      )}
      <div style={headerStyle}>
        <div style={headerInnerStyle}>
          <span style={titleStyle}>Apply for {job.jobrole}</span>
          <span style={jobIdStyle}>{job.jobid} · Fanisko Application Assistant</span>
        </div>
        <button type="button" aria-label="Close modal" onClick={onClose} style={closeButtonStyle}>
          &times;
        </button>
      </div>

      <div
        style={overlayStyle}
        onClick={(e) => {
          if (e.target === e.currentTarget) onClose();
        }}
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
          <aside style={sidebarStyle}>
            <div style={progressLabelStyle}>Application Progress</div>
            {steps.map((s, idx) => (
              <div
                key={s.label}
                style={
                  step === idx
                    ? updatedProgressItemActiveStyle                  // current (highlighted blue)
                    : idx < step
                      ? { ...updatedProgressItemStyle, color: "#53b775", fontWeight: 700 } // completed/green
                      : updatedProgressItemStyle                        // future (dimmed)
                }
              >
                <span style={progressItemIconStyle}>{s.icon}</span> {s.label}
              </div>
            ))}
          </aside>

          <section style={contentStyle}>
            <div style={{ width: "100%", maxWidth: 700 }}>
              {/* Resume Upload Step */}
              {step === 0 && (
                <>
                  <div style={chatBubbleStyle}>
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOAX4KQcp90_S1ckIoGXYY_SA58X3ODRQo05eykm5ndCieclMZ"
                      alt="Chatbot"
                      style={chatbotImgStyle}
                    />
                    <span>
                      Welcome to the application process for the position of {job.jobrole}. Please upload your resume and answer the following questions to help us better understand your profile. Your information will remain confidential and is used solely for evaluating your candidacy.
                    </span>
                  </div>
                  <form
                    onSubmit={(e) => e.preventDefault()}
                    style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}
                    autoComplete="off"
                  >
                    {!resume ? (
                      <div
                        style={dropZoneStyle(dragActive)}
                        onClick={() => fileInputRef.current?.click()}
                        onDragEnter={handleDrag}
                        onDragOver={handleDrag}
                        onDragLeave={handleDrag}
                        onDrop={handleDrop}
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") fileInputRef.current?.click();
                        }}
                        role="button"
                        aria-label="Upload resume"
                      >
                        <div style={{ color: "#233253", fontWeight: 600, fontSize: "1.25rem", marginBottom: 4 }}>
                          Drop your resume here
                        </div>
                        <div style={{ color: "#93939f", fontSize: "1.06rem" }}>or click to browse (PDF, DOCX - max 5MB)</div>
                        <button
                          type="button"
                          style={chooseFileButtonStyle}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            fileInputRef.current?.click();
                          }}
                        >
                          Choose File
                        </button>
                        <input
                          type="file"
                          ref={fileInputRef}
                          accept=".pdf, .docx"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          background: "#e7faec",
                          border: "2px solid #53b775",
                          color: "#22a768",
                          borderRadius: 14,
                          minHeight: 72,
                          display: "flex",
                          alignItems: "center",
                          gap: 17,
                          fontWeight: 600,
                          fontSize: "1.22rem",
                          padding: "0 25px",
                          marginTop: 20,
                          marginBottom: 14,
                        }}
                      >
                        <div
                          style={{
                            width: 34,
                            height: 34,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                            background: "#53b775",
                            color: "#fff",
                            fontSize: 23,
                            flexShrink: 0,
                          }}
                        >
                          ✓
                        </div>
                        <span style={{ wordBreak: "break-all" }}>{resume.name}</span>
                        <button
                          type="button"
                          onClick={() => {
                            setResume(null);
                            if (fileInputRef.current) fileInputRef.current.value = null;
                          }}
                          style={{
                            marginLeft: 18,
                            border: "none",
                            background: "transparent",
                            color: "#db5252",
                            fontWeight: "bold",
                            fontSize: "2rem",
                            lineHeight: 1,
                            cursor: "pointer",
                            padding: "0 6px",
                            flexShrink: 0,
                          }}
                          aria-label="Delete resume"
                          title="Remove selected resume"
                        >
                          ×
                        </button>
                      </div>
                    )}
                  </form>
                  {resume && (
                    <button
                      type="button"
                      onClick={handleNext}
                      style={{
                        float: "right",
                        marginTop: 8,
                        background: "#2373f0",
                        color: "#fff",
                        border: "none",
                        borderRadius: 7,
                        padding: "8px 22px",
                        fontWeight: 600,
                        fontSize: "1rem",
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(38,129,231,.09)",
                        userSelect: "none",
                      }}
                    >
                      Next
                    </button>
                  )}
                </>
              )}

              {/* Additional Details Step */}
              {step === 1 && (
                <>
                  <div style={chatContainerStyle}>
                    {chat.map((msg, i) => (
                      <div key={i} style={msg.type === "bot" ? botMsgStyle : userMsgStyle}>
                        {msg.type === "bot" && (
                          <img
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOAX4KQcp90_S1ckIoGXYY_SA58X3ODRQo05eykm5ndCieclMZ"
                            alt="Chatbot"
                            style={chatbotImgStyle}
                          />
                        )}
                        <span>{msg.text}</span>
                      </div>
                    ))}
                    <div ref={chatEndRef} />
                  </div>

                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      const q = additionalQuestions[questionIdx];
                      if (q.type === "coverLetter") {
                        if (coverLetterText.trim()) {
                          handleAnswer(q.key, coverLetterText.trim());   // Pure text
                          setCoverLetterText("");
                        } else if (coverLetterFile) {
                          handleAnswer(q.key, coverLetterFile.name, "Cover letter uploaded");
                        }
                      } else if (input.trim()) {
                        handleAnswer(q.key, input);
                      }
                    }}
                    style={inputRowStyle}
                  >
                    {(() => {
                      const q = additionalQuestions[questionIdx];
                      if (q.type === "coverLetter") {
                        return (
                          <>
                            <div style={{ display: "flex", flexDirection: "column", width: "100%", marginTop: -80 }}>
                              {/* Combined Drop Zone (Click or Drag) */}
                              <div
                                style={{
                                  border: coverLetterDragActive ? "2.5px solid #2373f0" : "2px solid #e3eafc",
                                  background: coverLetterDragActive ? "#e3f3fa" : "#f7f9fc",
                                  borderRadius: 15,
                                  padding: "18px 14px",
                                  marginBottom: 10,
                                  cursor: "pointer",
                                  textAlign: "center",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: 12
                                }}
                                onClick={() => {
                                  if (!coverLetterText.trim()) {
                                    coverLetterInputRef.current?.click();
                                  }
                                }}
                                onDragEnter={(e) => {
                                  e.preventDefault();
                                  setCoverLetterDragActive(true);
                                }}
                                onDragOver={(e) => {
                                  e.preventDefault();
                                  setCoverLetterDragActive(true);
                                }}
                                onDragLeave={(e) => {
                                  e.preventDefault();
                                  setCoverLetterDragActive(false);
                                }}
                                onDrop={(e) => {
                                  e.preventDefault();
                                  setCoverLetterDragActive(false);
                                  if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                                    const file = e.dataTransfer.files[0];
                                    if (validateFile(file)) {
                                      setCoverLetterFile(file);
                                      setCoverLetterName(file.name);
                                      setCoverLetterText("");
                                    }
                                  }
                                }}
                                tabIndex={0}
                                role="button"
                                aria-label="Drag or click to upload cover letter"
                              >
                                <span style={{ fontWeight: 600, color: "#2373f0", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "70%" }}>
                                  {coverLetterFile
                                    ? "selected: " + coverLetterFile.name
                                    : "Click or drag here to upload a cover letter file"}
                                </span>
                                {coverLetterFile && (
                                  <button
                                    type="button"
                                    onClick={e => {
                                      e.stopPropagation();
                                      setCoverLetterFile(null);
                                      setCoverLetterText("");
                                    }}
                                    style={{
                                      background: "#ffeaea",
                                      color: "#db5252",
                                      border: "none",
                                      borderRadius: "50%",
                                      width: 28,
                                      height: 28,
                                      fontSize: 17,
                                      fontWeight: "bold",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center"
                                    }}
                                    aria-label="Remove uploaded file"
                                    title="Remove uploaded file"
                                  >
                                    ×
                                  </button>
                                )}
                                <input
                                  type="file"
                                  style={{ display: "none" }}
                                  ref={coverLetterInputRef}
                                  accept=".pdf,.docx"
                                  onChange={handleCoverLetterChange}
                                />
                              </div>
                              {/* TextArea and Submit */}
                              <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-end", width: "100%", marginTop: -3, height: 80 }}>
                                <textarea
                                  value={coverLetterText}
                                  onChange={e => setCoverLetterText(e.target.value)}
                                  placeholder={q.placeholder}
                                  style={{
                                    ...inputBoxStyle,
                                    minHeight: 20,
                                    height: 506,
                                    marginTop: -3,
                                    maxHeight: 77,
                                    width: "72%",
                                    resize: "vertical",
                                    marginRight: 8,
                                    boxSizing: "border-box",
                                  }}
                                  disabled={!!coverLetterFile}
                                />
                                <button
                                  type="button"
                                  style={{
                                    ...sendBtnStyle,
                                    background: (coverLetterText.trim() || coverLetterFile) ? "#2373f0" : "#a3c6fa",
                                    minWidth: 46,
                                    minHeight: 46,
                                    fontSize: "1.2rem"
                                  }}
                                  disabled={!(coverLetterText.trim() || coverLetterFile) || uploading}
                                  aria-label="Submit cover letter"
                                  onClick={async () => {
                                    if (coverLetterText.trim()) {
                                      handleAnswer(q.key, coverLetterText.trim());
                                      setCoverLetterText("");
                                      setCoverLetterFile(null);
                                      return;
                                    }

                                    if (coverLetterFile) {
                                      setUploading(true);
                                      try {
                                        const formData = new FormData();
                                        formData.append("filename", coverLetterFile.name);
                                        formData.append("cover_letter", coverLetterFile);

                                        const response = await axios.post(
                                          // "https://screening.fanisko.com/api/upload_cover_letter",
                                          `${API_BASE_URL}/api/upload_cover_letter`,
                                          formData,
                                          { headers: { "Content-Type": "multipart/form-data" } }
                                        );

                                        const displayValue = `${coverLetterFile.name}_${response.data.file_id}`;
                                        handleAnswer(q.key, displayValue);
                                      } catch (err) {
                                        console.error(err);
                                        alert("Upload failed!");
                                      } finally {
                                        setUploading(false);
                                        setCoverLetterFile(null);
                                      }
                                    }
                                  }}
                                >
                                  {uploading ? "Uploading..." : "➤"}
                                </button>
                              </div>
                            </div>
                          </>
                        );
                      }
                      if (q.type === "options" && q.key !== "interview_time_slots") {
                        return (
                          <div style={{ display: "flex", gap: 10 }}>
                            {q.options.map((opt) => (
                              <button
                                key={opt}
                                type="button"
                                onClick={() => {
                                  if (isOptionDisabled) return;
                                  setIsOptionDisabled(true);
                                  handleAnswer(q.key, opt);
                                  setTimeout(() => setIsOptionDisabled(false), 500);
                                }}
                                disabled={isOptionDisabled}
                                style={{
                                  padding: "8px 16px",
                                  borderRadius: 8,
                                  border: "1px solid #2370f1",
                                  backgroundColor: "#f0f7ff",
                                  color: "#2370f1",
                                  fontWeight: "600",
                                  cursor: isOptionDisabled ? "not-allowed" : "pointer",
                                }}
                              >
                                {opt}
                              </button>
                            ))}
                          </div>
                        );
                      }
                      if (q.key === "jobChangeReason") {
                        return (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "flex-end",     // button and textarea baseline at bottom
                              marginTop: 4,
                              padding: 0,
                              minHeight: 70,              // Sets a reasonable container height
                              boxSizing: "border-box"
                            }}
                          >
                            <textarea
                              value={input}
                              onChange={e => setInput(e.target.value)}
                              placeholder={q.placeholder}
                              style={{
                                ...inputBoxStyle,
                                minHeight: 42,            // Slightly above default
                                maxHeight: 120,           // Not too tall
                                width: "95%",             // Leave space for the button
                                fontSize: "1.13rem",
                                lineHeight: 1.4,
                                border: "1.3px solid #2d3b51",
                                resize: "vertical",
                                overflowY: "auto",
                                marginBottom: 0,
                                marginRight: 7,
                                boxSizing: "border-box"
                              }}
                              rows={3}
                              autoFocus
                              disabled={isOptionDisabled}
                              aria-label={q.text}
                            />
                            <button
                              type="submit"
                              style={{
                                ...sendBtnStyle,
                                background: input ? "#2373f0" : "#a3c6fa",
                                minWidth: 46,
                                minHeight: 46,
                                fontSize: "1.2rem"
                              }}
                              disabled={!input || uploading}
                              aria-label="Submit interview date"
                            >
                              ➤
                            </button>
                          </div>
                        );
                      }
                      if (q.key === "interview_time_slots") {
                        return (
                          <>
                            <button
                              type="button"
                              style={{
                                ...chooseButtonStyle,
                                padding: '10px 50px',
                                borderRadius: 10,
                                backgroundColor: selectedTimeSlot ? '#1e90ff' : '#1d4c98ff',
                                color: '#fff',
                                fontWeight: 700,
                                fontSize: '1.08rem',
                              }}
                              onClick={() => setShowTimeOverlay(true)}
                            >
                              {selectedTimeSlot ? `Selected: ${selectedTimeSlot}` : 'Choose Time Slot'}
                            </button>
                            {showTimeOverlay && (
                              <div
                                style={{
                                  position: 'fixed',
                                  top: 0, left: 0, right: 0, bottom: 0,
                                  background: 'rgba(0,0,0,0.22)',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  zIndex: 2300
                                }}
                                onClick={() => setShowTimeOverlay(false)}
                              >
                                <div
                                  style={{
                                    background: '#fff',
                                    borderRadius: 15,
                                    padding: 32,
                                    minWidth: 320,
                                    maxWidth: 520,
                                    boxShadow: '0 8px 32px rgba(38,129,231,0.13)',
                                    position: 'relative'
                                  }}
                                  onClick={e => e.stopPropagation()}
                                >
                                  <button
                                    aria-label="Close"
                                    style={{
                                      position: 'absolute',
                                      right: 14, top: 10, fontSize: 28, border: 'none',
                                      background: 'none', color: '#2373f0', cursor: 'pointer'
                                    }}
                                    onClick={() => setShowTimeOverlay(false)}
                                  >×</button>
                                  <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 20 }}>Select a Time Slot</div>
                                  <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(3, 1fr)', // 3 columns
                                    gap: 14,
                                    justifyItems: 'center'
                                  }}>
                                    {q.options.map(opt => (
                                      <button
                                        key={opt}
                                        style={{
                                          width: 160,
                                          padding: '13px 0px',
                                          borderRadius: 9,
                                          border: selectedTimeSlot === opt ? '2px solid #2373f0' : '1px solid #c8d6fa',
                                          background: selectedTimeSlot === opt ? '#2373f0' : '#f7fafe',
                                          color: selectedTimeSlot === opt ? '#fff' : '#2373f0',
                                          fontWeight: 700,
                                          cursor: isOptionDisabled ? 'not-allowed' : 'pointer',
                                          textAlign: 'center'
                                        }}
                                        disabled={isOptionDisabled}
                                        onClick={() => {
                                          if (isOptionDisabled) return;
                                          setIsOptionDisabled(true);
                                          setSelectedTimeSlot(opt);
                                          setShowTimeOverlay(false);
                                          handleAnswer(q.key, opt);
                                          setTimeout(() => setIsOptionDisabled(false), 500); // Or after advancing question
                                        }}
                                      >
                                        {opt}
                                      </button>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        );
                      }

                      if (q.key === "noticePeriod") {
                        const options = ["1-2 months", "3-4 months", "5-6 months", "More than 6 months"];
                        return (
                          <div style={{ display: "flex", gap: 10 }}>
                            {options.map((opt) => (
                              <button
                                key={opt}
                                type="button"
                                disabled={isOptionDisabled}
                                onClick={() => {
                                  if (isOptionDisabled) return;
                                  setIsOptionDisabled(true);
                                  handleAnswer(q.key, opt);
                                  setTimeout(() => setIsOptionDisabled(false), 500); // Or after next question
                                }}
                                style={{
                                  padding: "8px 16px",
                                  borderRadius: 8,
                                  border: "1px solid #2370f1",
                                  backgroundColor: "#f0f7ff",
                                  color: "#2370f1",
                                  fontWeight: "600",
                                  cursor: isOptionDisabled ? "not-allowed" : "pointer",
                                }}
                              >
                                {opt}
                              </button>
                            ))}
                          </div>
                        );
                      }
                      if (q.key === "interview_date") {
                        // HR sets the range in job.onboarding[key].value
                        const from = job.onboarding["interview_date"]?.value?.from;
                        const to = job.onboarding["interview_date"]?.value?.to;
                        return (
                          <>
                            <input
                              type="date"
                              min={from}
                              max={to}
                              style={{ ...inputBoxStyle }}
                              value={input}
                              onChange={e => setInput(e.target.value)}
                            />
                            <button
                              type="submit"
                              style={{
                                ...sendBtnStyle,
                                background: input ? "#2373f0" : "#a3c6fa",
                                minWidth: 46,
                                minHeight: 46,
                                fontSize: "1.2rem"
                              }}
                              disabled={!input || uploading}
                              aria-label="Submit interview date"
                            >
                              ➤
                            </button>
                          </>
                        );
                      }



                      // Default for text and number inputs
                      return (
                        <>
                          <input
                            type={q.type === "number" ? "number" : "text"}
                            placeholder={q.placeholder}
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            style={inputBoxStyle}
                            // Add your onKeyDown here to restrict e,+,-,.
                            onKeyDown={(e) => {
                              if (q.key === "expectedSalary" && ["e", "E", "+", "-", "."].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            min={q.key === "expectedSalary" ? 0 : undefined}
                            step={q.key === "expectedSalary" ? 1 : undefined}
                          />
                          <button
                            type="submit"
                            style={{
                              ...sendBtnStyle,
                              background: input.trim() ? "#2373f0" : "#a3c6fa"
                            }}
                            disabled={!input.trim()}
                            aria-label="Send answer"
                          >
                            ➤
                          </button>
                        </>
                      );
                    })()}
                  </form>
                </>
              )}

              {/* ##################################################################################### */}
              {step === 2 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    width: "100%",
                    height: `calc(100vh - ${headerHeight + 20}px)`,
                    background: "transparent",
                  }}
                >
                  <div style={{ minWidth: 54, paddingTop: 32 }}>
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOAX4KQcp90_S1ckIoGXYY_SA58X3ODRQo05eykm5ndCieclMZ"
                      alt="Chatbot"
                      style={{
                        width: 38,
                        height: 38,
                        borderRadius: "50%",
                        background: "#e3eafc",
                        boxShadow: "0 2px 8px rgba(38,129,231,.09)",
                      }}
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 0",
                      maxWidth: 670,
                      minWidth: 350,
                      marginLeft: 28,
                      background: "#fff",
                      borderRadius: 18,
                      boxShadow: "0 4px 22px rgba(38,129,231,.11)",
                      padding: "32px 38px 32px 38px",
                      display: "flex",
                      flexDirection: "column",
                      boxSizing: "border-box",
                      maxHeight: `calc(100vh - ${headerHeight + 80}px)`,
                      overflowY: "auto",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 700,
                        fontSize: 21,
                        marginBottom: 24,
                        color: "#233253",
                      }}
                    >
                      Application Complete!
                      <br />
                      Please review your application summary below before submission.
                      <button
                        type="button"
                        onClick={() => {
                          setEditAllValues({
                            ...personalInfo,
                            ...answers,
                            coverLetter: answers.coverLetter || answers.cover_letter || "",
                            coverLetterText:
                              // If answer is a text (not file pattern), use it, else empty
                              (answers.coverLetter && !answers.coverLetter.includes("_")) ? answers.coverLetter
                                : (answers.cover_letter && !answers.cover_letter.includes("_") ? answers.cover_letter : "")
                          });
                          setIsEditingAll(true);
                        }}
                        style={{
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                          float: "right",
                          color: "#2373f0",
                          fontSize: 20,
                          fontWeight: "bold",
                          transform: "scaleX(-1)",
                          marginLeft: 14,
                        }}
                        aria-label="Edit all answers"
                        title="Edit"
                      >
                        ✎
                      </button>
                    </div>

                    {!isEditingAll ? (
                      <div style={{ flex: 1, overflowY: "auto", paddingRight: 8 }}>
                        <ul style={{ paddingLeft: 24, listStyleType: "square", color: "#231c1cff" }}>
                          {/* Personal Info */}
                          <li style={{ marginBottom: 12 }}>
                            <strong>First Name:</strong><br />
                            {personalInfo.first_name === undefined ? "Extracting..." : personalInfo.first_name}
                          </li>
                          <li style={{ marginBottom: 12 }}>
                            <strong>Last Name:</strong><br />
                            {personalInfo.last_name === undefined ? "Extracting..." : personalInfo.last_name || "—"}
                          </li>
                          <li style={{ marginBottom: 12 }}>
                            <strong>E-mail:</strong><br />
                            {personalInfo.email === undefined ? "Extracting..." : (personalInfo.email || "—")}
                          </li>
                          <li style={{ marginBottom: 12 }}>
                            <strong>Phone:</strong><br />
                            {personalInfo.phone === undefined ? "Extracting..." : (personalInfo.phone || "—")}
                          </li>


                          {additionalQuestions.map((q) => {
                            console.log("personalInfo:", personalInfo);
                            let val = answers[q.key];
                            if (!val && (q.key === "coverLetter" || q.key === "cover_letter")) {
                              val = answers.cover_letter || answers.coverLetter;
                            }
                            if (val && typeof val === "object" && "value" in val) {
                              val = val.value;
                            }
                            if ((q.key === "cover_letter") && answers.has_cover_letter === "No") return null;
                            // ---- CONDITION TO SKIP PREFERRED CITY ----
                            if (q.key === "preferred_city" && answers.work_mode === "Remote") return null;

                            if (q.type === "coverLetter" && val && typeof val === "string" && val.includes("_")) {
                              const lastUnderscoreIndex = val.lastIndexOf("_");
                              const filename = val.slice(0, lastUnderscoreIndex);
                              const fileId = val.slice(lastUnderscoreIndex + 1);
                              return (
                                <li key={q.key} style={{ marginBottom: 12 }}>
                                  <strong>{q.text}:</strong><br />{filename} (ID: {fileId})
                                </li>
                              );
                            }
                            if (q.type === "coverLetter" && val && typeof val === "string" && val.trim() && !val.includes("_")) {
                              // TEXT input - show the text
                              return (
                                <li key={q.key} style={{ marginBottom: 12 }}>
                                  <strong>{q.text}:</strong><br />{val}
                                </li>
                              );
                            }
                            return (
                              <li
                                key={q.key}
                                style={{
                                  marginBottom: 12,
                                  whiteSpace: "pre-wrap",      // Preserves newlines/returns and wraps long lines
                                  wordBreak: "break-word"      // Ensures long words do not overflow
                                }}
                              >
                                <strong>{q.text}:</strong><br />{val || "—"}
                              </li>

                            );
                          })}
                        </ul>

                        {/* Verification checkbox */}
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontSize: 12,
                            fontWeight: 500,
                            marginTop: 16,
                            color: "#202640",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={isVerified}
                            onChange={(e) => setIsVerified(e.target.checked)}
                            style={{ marginRight: 8 }}
                          />
                          I confirm that the details provided in this application are accurate and complete.
                        </label>

                        {/* Submit Button */}
                        <div style={{ marginTop: 36, display: "flex", justifyContent: "flex-end" }}>
                          <button
                            type="button"
                            onClick={handleFinalSubmit}
                            disabled={!isVerified || loading || isExtracting}
                            style={{
                              width: "100%",
                              padding: "14px 0",
                              textAlign: "center",
                              fontWeight: "600",
                              fontSize: "18px",
                              color: "#fff",
                              backgroundColor: isVerified && !isExtracting ? "#2373f0" : "#c6d4ecff",
                              border: "none",
                              borderRadius: "7px",
                              cursor: isVerified && !isExtracting ? "pointer" : "not-allowed",
                            }}
                          >
                            {loading ? "Submitting..." : "Submit Application"}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <form
                        onSubmit={e => {
                          e.preventDefault();

                          // Check all values first for blank
                          for (const q of additionalQuestions) {
                            // Skip coverLetter question if hasCoverLetter is No
                            if (
                              (q.key !== "preferred_city" ||
                                (q.key === "preferred_city" && editAllValues.work_mode !== "Remote")) &&
                              !(q.key === "cover_letter" && (editAllValues.has_cover_letter === "No" || editAllValues.has_cover_letter === false))
                            ) {
                              if (
                                q.key === "cover_letter" &&
                                !(
                                  (editAllValues.cover_letter && editAllValues.cover_letter.trim() !== "") ||
                                  (editAllValues.cover_letter_text && editAllValues.cover_letter_text.trim() !== "")
                                )
                              ) {
                                alert(`${q.text} cannot be empty.`);
                                return;
                              }
                              if (
                                q.key !== "cover_letter" &&
                                (
                                  editAllValues[q.key] === undefined ||
                                  editAllValues[q.key] === null ||
                                  (typeof editAllValues[q.key] === "string" && editAllValues[q.key].trim() === "")
                                )
                              ) {
                                alert(`${q.text} cannot be empty.`);
                                return;
                              }
                            }
                          }

                          // First Name
                          if (!editAllValues.first_name || !/^[A-Za-z ]+$/.test(editAllValues.first_name.trim())) {
                            alert("First name is required and must only contain letters.");
                            return;
                          }

                          // Last Name
                          if (!editAllValues.last_name || !/^[A-Za-z ]+$/.test(editAllValues.last_name.trim())) {
                            alert("Last name is required and must only contain letters.");
                            return;
                          }

                          // Email
                          if (!editAllValues.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editAllValues.email.trim())) {
                            alert("Please enter a valid email address.");
                            return;
                          }

                          // Phone
                          if (!editAllValues.phone || !/^\+?\d+$/.test(editAllValues.phone.trim())) {
                            alert("Phone number is required and must contain only digits and an optional leading plus sign (+).");
                            return;
                          }

                          // LinkedIn validation
                          if (editAllValues.linkedin && !validateLinkedInUrlFrontend(editAllValues.linkedin)) {
                            alert("Please enter a valid LinkedIn profile URL.");
                            return;
                          }

                          // Salary validations with snake_case keys
                          if (editAllValues.current_salary && !validateCurrentSalary(editAllValues.current_salary)) {
                            alert("Please enter a positive number for current salary or 'NA' if not applicable.");
                            return;
                          }

                          if (editAllValues.expected_salary && !validateExpectedSalary(editAllValues.expected_salary, editAllValues.current_salary)) {
                            alert("Please enter a valid expected salary greater than 0 and not less than your current salary (unless current salary is 'NA').");
                            return;
                          }

                          // Interview date validation
                          if (editAllValues.interview_date && !validateInterviewDate(editAllValues.interview_date)) {
                            alert("Please select an interview date within the next 6 months.");
                            return;
                          }

                          const updatedAnswers = {};

                          additionalQuestions.forEach(q => {
                            updatedAnswers[q.key] = editAllValues[q.key] || "";
                          });

                          setAnswers(prev => ({
                            ...prev,
                            ...updatedAnswers
                          }));


                          setPersonalInfo({
                            first_name: editAllValues.first_name,
                            last_name: editAllValues.last_name,
                            email: editAllValues.email,
                            phone: editAllValues.phone,
                          });

                          setIsEditingAll(false);
                        }}
                        style={{
                          flex: 1,
                          overflowY: "auto",
                          paddingRight: 8,
                          display: "flex",
                          flexDirection: "column",
                          minHeight: 0,
                        }}
                      >
                        {/* Editable personal info fields */}
                        <div style={{ marginBottom: 18 }}>
                          <label
                            htmlFor="edit-first_name"
                            style={{ fontWeight: 600, display: "block", marginBottom: 7, color: "#233253" }}
                          >
                            First Name
                          </label>
                          <input
                            id="edit-first_name"
                            type="text"
                            value={editAllValues.first_name || ""}
                            onChange={(e) => setEditAllValues((prev) => ({ ...prev, first_name: e.target.value }))}
                            style={{
                              width: "100%",
                              fontWeight: 500,
                              fontSize: 17,
                              borderRadius: 6,
                              padding: "10px 12px",
                              border: "1.5px solid #dde6f2",
                              background: "#fff",
                            }}
                          />
                        </div>
                        <div style={{ marginBottom: 18 }}>
                          <label
                            htmlFor="edit-last_name"
                            style={{ fontWeight: 600, display: "block", marginBottom: 7, color: "#233253" }}
                          >
                            Last Name
                          </label>
                          <input
                            id="edit-last_name"
                            type="text"
                            value={editAllValues.last_name || ""}
                            onChange={(e) => setEditAllValues((prev) => ({ ...prev, last_name: e.target.value }))}
                            style={{
                              width: "100%",
                              fontWeight: 500,
                              fontSize: 17,
                              borderRadius: 6,
                              padding: "10px 12px",
                              border: "1.5px solid #dde6f2",
                              background: "#fff",
                            }}
                          />
                        </div>
                        <div style={{ marginBottom: 18 }}>
                          <label
                            htmlFor="edit-email"
                            style={{ fontWeight: 600, display: "block", marginBottom: 7, color: "#233253" }}
                          >
                            Email
                          </label>
                          <input
                            id="edit-email"
                            type="email"
                            value={editAllValues.email || ""}
                            onChange={(e) => setEditAllValues((prev) => ({ ...prev, email: e.target.value }))}
                            style={{
                              width: "100%",
                              fontWeight: 500,
                              fontSize: 17,
                              borderRadius: 6,
                              padding: "10px 12px",
                              border: "1.5px solid #dde6f2",
                              background: "#fff",
                            }}
                          />
                        </div>
                        <div style={{ marginBottom: 18 }}>
                          <label
                            htmlFor="edit-phone"
                            style={{ fontWeight: 600, display: "block", marginBottom: 7, color: "#233253" }}
                          >
                            Phone
                          </label>
                          <input
                            id="edit-phone"
                            type="text"
                            value={editAllValues.phone || ""}
                            onChange={(e) => setEditAllValues((prev) => ({ ...prev, phone: e.target.value }))}
                            style={{
                              width: "100%",
                              fontWeight: 500,
                              fontSize: 17,
                              borderRadius: 6,
                              padding: "10px 12px",
                              border: "1.5px solid #dde6f2",
                              background: "#fff",
                            }}
                          />
                        </div>

                        {additionalQuestions
                          .filter(q =>
                            // Skip preferredCity question if workMode is Remote
                            // !(q.key === "preferredCity" && editAllValues.workMode === "Remote")
                            // Skip coverLetter question if hasCoverLetter is No or false
                            !(q.key === "preferred_city" && editAllValues.work_mode === "Remote") && !(q.key === "cover_letter" && editAllValues.has_cover_letter === "No"))
                          .map((question) => (
                            <div key={question.key} style={{ marginBottom: 18 }}>
                              <label
                                htmlFor={`edit-${question.key}`}
                                style={{
                                  fontWeight: 600,
                                  display: "block",
                                  marginBottom: 7,
                                  color: "#233253"
                                }}
                              >
                                {question.text}
                              </label>

                              {question.key === "cover_letter" ? (
                                <>
                                  <div
                                    style={{
                                      border: editAllValues.cover_letter_drag_active ? "2.5px solid #2373f0" : "2px solid #e3eafc",
                                      background: editAllValues.cover_letter_drag_active ? "#e3f3fa" : "#f7f9fc",
                                      borderRadius: 15,
                                      padding: "18px 14px",
                                      marginBottom: 8,
                                      cursor: "pointer",
                                      textAlign: "center",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 12,
                                      minHeight: '38px',
                                      opacity: editAllValues.cover_letter_text?.trim() ? 0.5 : 1,
                                      pointerEvents: editAllValues.cover_letter_text?.trim() ? "none" : "auto",
                                    }}
                                    tabIndex={0}
                                    aria-disabled={!!editAllValues.cover_letter_text?.trim()}
                                    onClick={() => {
                                      if (!editAllValues.cover_letter_text?.trim()) {
                                        coverLetterInputRef.current?.click();
                                      }
                                    }}
                                    onDragEnter={(e) => {
                                      e.preventDefault();
                                      setEditAllValues(prev => ({
                                        ...prev,
                                        cover_letter_drag_active: true
                                      }));
                                    }}
                                    onDragOver={(e) => {
                                      e.preventDefault();
                                      setEditAllValues(prev => ({
                                        ...prev,
                                        cover_letter_drag_active: true
                                      }));
                                    }}
                                    onDragLeave={(e) => {
                                      e.preventDefault();
                                      setEditAllValues(prev => ({
                                        ...prev,
                                        cover_letter_drag_active: false
                                      }));
                                    }}
                                    onDrop={async (e) => {
                                      e.preventDefault();
                                      setEditAllValues(prev => ({
                                        ...prev,
                                        cover_letter_drag_active: false
                                      }));
                                      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                                        const file = e.dataTransfer.files[0];
                                        // Upload the file to backend
                                        const formData = new FormData();
                                        formData.append("filename", file.name);
                                        formData.append("cover_letter", file);
                                        try {
                                          const response = await axios.post(
                                            // "https://screening.fanisko.com/api/upload_cover_letter",
                                            `${API_BASE_URL}/api/upload_cover_letter`,
                                            formData,
                                            { headers: { "Content-Type": "multipart/form-data" } }
                                          );
                                          const displayValue = `${response.data.filename}_${response.data.file_id}`;
                                          setEditAllValues(prev => ({
                                            ...prev,
                                            cover_letter: displayValue,
                                            cover_letter_file: file,
                                            cover_letter_text: ""
                                          }));
                                        } catch (err) {
                                          console.error(err);
                                          alert("Upload failed!");
                                        }
                                      }
                                    }}
                                  >
                                    <span style={{ fontWeight: 600, color: "#2373f0", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "65%" }}>
                                      {typeof editAllValues.cover_letter === "string" && editAllValues.cover_letter.includes("_")
                                        ? (() => {
                                          const lastUnderscoreIndex = editAllValues.cover_letter.lastIndexOf("_");
                                          const filename = editAllValues.cover_letter.slice(0, lastUnderscoreIndex);
                                          const fileId = editAllValues.cover_letter.slice(lastUnderscoreIndex + 1);
                                          return `selected: ${filename} (ID: ${fileId})`;
                                        })()
                                        : "Click or drag here to upload a cover letter file"}
                                    </span>
                                    {/* Remove button only if file is selected */}
                                    {typeof editAllValues.cover_letter === "string" && editAllValues.cover_letter.includes("_") && (
                                      <button
                                        type="button"
                                        onClick={e => {
                                          e.stopPropagation();
                                          setEditAllValues(prev => ({
                                            ...prev,
                                            cover_letter: "",
                                            cover_letter_file: null,
                                            cover_letter_text: ""
                                          }));
                                        }}
                                        style={{
                                          color: "#db5252",
                                          cursor: "pointer",
                                          background: "#ffeaea",
                                          border: "none",
                                          borderRadius: "50%",
                                          width: 28,
                                          height: 28,
                                          fontSize: 18,
                                          fontWeight: "bold",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          marginLeft: 6
                                        }}
                                        aria-label="Remove uploaded cover letter"
                                        title="Remove cover letter"
                                      >
                                        ×
                                      </button>
                                    )}
                                    <input
                                      type="file"
                                      ref={coverLetterInputRef}
                                      style={{ display: "none" }}
                                      accept=".pdf,.docx"
                                      onChange={async (e) => {
                                        const file = e.target.files?.[0];
                                        if (!file) return;
                                        // Upload the file to backend
                                        const formData = new FormData();
                                        formData.append("filename", file.name);
                                        formData.append("cover_letter", file);
                                        try {
                                          const response = await axios.post(
                                            // "https://screening.fanisko.com/api/upload_cover_letter",
                                            `${API_BASE_URL}/api/upload_cover_letter`,
                                            formData,
                                            { headers: { "Content-Type": "multipart/form-data" } }
                                          );
                                          const displayValue = `${response.data.filename}_${response.data.file_id}`;
                                          setEditAllValues(prev => ({
                                            ...prev,
                                            cover_letter: displayValue,
                                            cover_letter_file: file,
                                            cover_letter_text: ""
                                          }));
                                        } catch (err) {
                                          console.error(err);
                                          alert("Upload failed!");
                                        }
                                      }}
                                    />
                                  </div>
                                  <textarea
                                    value={editAllValues.cover_letter_text || ""}
                                    onChange={e =>
                                      setEditAllValues(prev => ({
                                        ...prev,
                                        cover_letter_text: e.target.value
                                      }))
                                    }
                                    rows={4}
                                    placeholder="Or, type your cover letter here..."
                                    style={{
                                      width: "95%",
                                      borderRadius: 8,
                                      border: "1.2px solid #000000ff",
                                      padding: "9px 12px",
                                      fontSize: 15,
                                      color: "#333333",
                                      background: "#f7fbff",
                                      marginTop: 8,
                                      marginBottom: 0,
                                      opacity:
                                        !!editAllValues.cover_letter && editAllValues.cover_letter.includes("_")
                                          ? 0.5
                                          : 1
                                    }}
                                    disabled={
                                      !!editAllValues.cover_letter && editAllValues.cover_letter.includes("_")
                                    } // Disable if file is selected
                                  />
                                </>

                              ) : question.key === "notice_period" ? (
                                <select
                                  id={`edit-${question.key}`}
                                  value={editAllValues[question.key] || ""}
                                  onChange={e =>
                                    setEditAllValues(prev => ({ ...prev, [question.key]: e.target.value }))
                                  }
                                  style={{ ...inputBoxStyle, maxWidth: 320 }}
                                >
                                  <option value="" disabled>Select notice period</option>
                                  {["Immediate", "1-2 months", "3-4 months", "5-6 months", "More than 6 months"].map(opt => (
                                    <option key={opt} value={opt}>{opt}</option>
                                  ))}
                                </select>
                              ) :
                                question.key === "job_change_reason" ? (
                                  <textarea
                                    id={`edit-${question.key}`}
                                    value={editAllValues[question.key] || ""}
                                    placeholder={question.placeholder || ""}
                                    onChange={e =>
                                      setEditAllValues((prev) => ({
                                        ...prev,
                                        [question.key]: e.target.value,
                                      }))
                                    }
                                    style={{
                                      ...inputBoxStyle,
                                      minHeight: 90,
                                      maxHeight: 220,
                                      fontSize: "1.13rem",
                                      lineHeight: 1.5,
                                      border: "1.3px solid #2d3b51",
                                      resize: "vertical",
                                      overflowY: "auto",
                                      marginBottom: 0,
                                      width: "100%",
                                      boxSizing: "border-box"
                                    }}
                                    rows={5}
                                    autoFocus={questionIdx === question.key}
                                    disabled={isOptionDisabled}
                                    aria-label={question.text}
                                  />
                                ) : question.key === "interview_date" ? (
                                  <input
                                    id={`edit-${question.key}`}
                                    type="date"
                                    min={formatDate((() => {
                                      const minDate = new Date();
                                      minDate.setDate(minDate.getDate() + 3);
                                      return minDate;
                                    })())}
                                    max={formatDate((() => {
                                      const maxDate = new Date();
                                      maxDate.setMonth(maxDate.getMonth() + 6);
                                      return maxDate;
                                    })())}
                                    value={editAllValues[question.key] || ""}
                                    onChange={e =>
                                      setEditAllValues(prev => ({ ...prev, [question.key]: e.target.value }))
                                    }
                                    style={{ ...inputBoxStyle, maxWidth: 320 }}
                                  />
                                ) : question.key === "interview_time_slots" ? (
                                  <>
                                    <button
                                      type="button"
                                      onClick={() => setShowTimeOverlay(true)}
                                      style={{
                                        ...chooseButtonStyle,
                                        backgroundColor: editAllValues[question.key] ? "#2373f0" : "#3a7dec",
                                        padding: "12px 24px",
                                        borderRadius: 10,
                                        minWidth: 180,
                                        fontWeight: 600,
                                        fontSize: '1rem',
                                        marginBottom: 12,
                                        color: "#fff"
                                      }}
                                    >
                                      {editAllValues[question.key]
                                        ? `Selected: ${editAllValues[question.key]}`
                                        : "Choose Time Slot"}
                                    </button>

                                    {showTimeOverlay && (
                                      <div
                                        onClick={() => setShowTimeOverlay(false)}
                                        style={{
                                          position: "fixed",
                                          inset: 0,
                                          backgroundColor: "rgba(35,115,240,0.1)",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          zIndex: 3000
                                        }}
                                      >
                                        <div
                                          onClick={e => e.stopPropagation()}
                                          style={{
                                            backgroundColor: "#fff",
                                            padding: 36,
                                            borderRadius: 14,
                                            boxShadow: "0 8px 24px rgba(38,129,231,.16)",
                                            maxWidth: 480,
                                            width: '90vw',
                                            position: "relative",
                                          }}
                                        >
                                          <button
                                            onClick={() => setShowTimeOverlay(false)}
                                            aria-label="Close overlay"
                                            style={{
                                              position: "absolute",
                                              right: 24,
                                              top: 24,
                                              fontSize: 26,
                                              color: "#2373f0",
                                              cursor: "pointer",
                                              border: 'none',
                                              background: "none",
                                            }}
                                          >×</button>
                                          <h3 style={{ color: "#2373f0", marginBottom: 20, fontWeight: 700 }}>
                                            Select a Time Slot
                                          </h3>
                                          <div style={{ display: "flex", flexWrap: "wrap", gap: 14, justifyContent: "center" }}>
                                            {question.options.map(opt => (
                                              <button
                                                key={opt}
                                                style={{
                                                  padding: "15px 8px",
                                                  width: 140,
                                                  borderRadius: 14,
                                                  border: editAllValues[question.key] === opt
                                                    ? "2.4px solid #2373f0" : "1.5px solid #bddafe",
                                                  backgroundColor: editAllValues[question.key] === opt
                                                    ? "linear-gradient(95deg, #2373f0 80%, #44affe 100%)" : "#f8fbfe",
                                                  color: editAllValues[question.key] === opt ? "#000" : "#2373f0",
                                                  fontWeight: 700,
                                                  cursor: "pointer",
                                                  fontSize: "1.04rem"
                                                }}
                                                onClick={() => {
                                                  setEditAllValues(prev => ({ ...prev, [question.key]: opt }));
                                                  setShowTimeOverlay(false);
                                                }}
                                              >
                                                {opt}
                                              </button>
                                            ))}
                                          </div>
                                          <button
                                            onClick={() => setShowTimeOverlay(false)}
                                            style={{
                                              marginTop: 18,
                                              padding: "10px 18px",
                                              borderRadius: 8,
                                              border: "none",
                                              background: "#ddddddff",
                                              cursor: "pointer"
                                            }}
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                ) : question.type === "options" ? (
                                  question.options.map((option) => (
                                    <label
                                      key={option}
                                      style={{
                                        marginRight: 22,
                                        fontWeight: 500,
                                        color: "#2373f0",
                                        cursor: "pointer"
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        name={question.key}
                                        value={option}
                                        checked={editAllValues[question.key] === option}
                                        onChange={e =>
                                          setEditAllValues((prev) => ({
                                            ...prev,
                                            [question.key]: e.target.value,
                                          }))
                                        }
                                        style={{ marginRight: 7 }}
                                      />
                                      {option}
                                    </label>
                                  ))
                                ) : (
                                  <input
                                    id={`edit-${question.key}`}
                                    type={question.type === "number" ? "number" : "text"}
                                    value={editAllValues[question.key] || ""}
                                    placeholder={question.placeholder || ""}
                                    onChange={e =>
                                      setEditAllValues((prev) => ({
                                        ...prev,
                                        [question.key]: e.target.value,
                                      }))
                                    }
                                    style={inputBoxStyle}
                                  />
                                )}
                            </div>
                          ))}

                        <div style={{ marginTop: 18, display: "flex", gap: 14 }}>
                          <button
                            type="submit"
                            style={{
                              background: "#2373f0",
                              color: "#fff",
                              border: "none",
                              borderRadius: 7,
                              padding: "12px 30px",
                              fontWeight: "600",
                              cursor: "pointer",
                              fontSize: 17,
                            }}
                          >
                            Update
                          </button>
                          <button
                            type="button"
                            style={{
                              background: "#e3f2ff",
                              color: "#2373f0",
                              border: "none",
                              borderRadius: 7,
                              padding: "12px 30px",
                              fontWeight: "600",
                              cursor: "pointer",
                              fontSize: 17,
                            }}
                            onClick={() => setIsEditingAll(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              )}

            </div>
          </section>
        </div>
      </div>
    </>
  );
}
